import React from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const DetallesOT = ({ caso }) => {
  const theme = useSelector((state) => state.theme.theme) || "light";
  const history = useHistory();

  // Función para navegar al perfil del cliente
  const navegarAPerfilCliente = (clienteId) => {
    if (clienteId) {
      history.push(`/contact/${clienteId}/contact_profile`);
    }
  };

  // Función para renderizar un valor de manera segura
  const renderValue = (value, isClickable = false, onClick = null) => {
    if (value === null || value === undefined || value === "") {
      return <span className="text-muted font-italic">No especificado</span>;
    }

    if (isClickable && onClick) {
      return (
        <span className="highlight" onClick={onClick}>
          {String(value)}
        </span>
      );
    }

    return String(value);
  };

  // Componente para mostrar un campo individual
  const InfoField = ({ label, value, isClientLink = false, clienteId = null }) => {
    return (
      <div className="vb-field-group">
        <div className="vb-field-label">
          {label}
        </div>
        <div className="vb-field-value">
          {isClientLink ? (
            <span
              className="highlight"
              onClick={() => navegarAPerfilCliente(clienteId)}
            >
              <i className="fas fa-user-circle me-1"></i>
              {value}
            </span>
          ) : (
            renderValue(value)
          )}
        </div>
      </div>
    );
  };

  // Función para renderizar una sección de datos
  const renderSection = (title, data, icon) => {
    if (!data || Object.keys(data).length === 0) {
      return null;
    }

    const dataEntries = Object.entries(data).filter(([key, value]) =>
      value !== null && value !== undefined && value !== ""
    );
    const totalFields = dataEntries.length;

    if (totalFields === 0) return null;

    return (
      <div className="vb-section-card">
        <div className="vb-card-header">
          <i className={icon}></i>
          <span>{title}</span>
        </div>
        <div className="vb-card-body">
          <Row>
            {dataEntries.map(([key, value]) => (
              <Col lg={6} md={6} sm={12} key={key}>
                <InfoField
                  label={key}
                  value={typeof value === 'object' && value.isClientLink ? value.nombre : value}
                  isClientLink={typeof value === 'object' && value.isClientLink}
                  clienteId={typeof value === 'object' && value.isClientLink ? value.clienteId : null}
                />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );
  };

  // Preparar los datos organizados
  const detallesBasicos = {
    "Fecha de Creación": caso.created_date,
    "Fecha PQR": caso.fecha_pqr + (caso.hora_pqr ? ` - ${caso.hora_pqr}` : ""),
    "Tipo de OT": caso.tipo_caso,
    "Número de Reclamo": caso.numero_reclamo,
    "Tipo de Reclamo": caso.tipo_reclamo,
    "Tipo de Servicio": caso.tipo_servicio
  };

  // Agregar cliente principal si existe
  if (caso.cliente && caso.cliente.length > 0) {
    const clientePrincipal = caso.cliente[0];
    const nombreCliente = clientePrincipal.get_full_name || clientePrincipal.full_name || clientePrincipal[0] || clientePrincipal;
    const clienteId = clientePrincipal.id || clientePrincipal.contact_id;

    if (nombreCliente && clienteId) {
      detallesBasicos["Cliente"] = {
        isClientLink: true,
        nombre: nombreCliente,
        clienteId: clienteId
      };
    } else if (nombreCliente) {
      detallesBasicos["Cliente"] = nombreCliente;
    }
  }

  const descripcionYObservaciones = {
    "Descripción": caso.descripcion,
    "Observaciones": caso.observaciones
  };

  if (caso.tipo_servicio === "DESPLAZAMIENTO") {
    descripcionYObservaciones["Ubicación"] = caso.direccion_1;
    descripcionYObservaciones["Destino"] = caso.direccion_2;
  }

  const agentesData = {};
  if (caso.contacto && caso.contacto.length > 0) {
    caso.contacto.forEach((contacto, index) => {
      const nombre = contacto.full_name || contacto[0] || contacto;
      const rol = contacto.rol ? ` (${contacto.rol})` : "";
      agentesData[`Agente ${index + 1}`] = nombre + rol;
    });
  }

  return (
    <div className="vb-scroll-container" data-theme={theme}>
      {/* Detalles Básicos */}
      {renderSection(
        "Información Básica",
        detallesBasicos,
        "fas fa-info-circle"
      )}

      {/* Descripción y Observaciones */}
      {renderSection(
        "Descripción y Observaciones",
        descripcionYObservaciones,
        "fas fa-file-alt"
      )}

      {/* Agentes */}
      {Object.keys(agentesData).length > 0 && renderSection(
        "Agentes Asignados",
        agentesData,
        "fas fa-users"
      )}
    </div>
  );
};

export default DetallesOT;